export const environment = {
  production: false,
  basicPass: 'Basic YWRtaW46SGFpbmVAMTA=',
  backendUrl: '/portalprojetos/api',
  auth: '/portalprojetos',
  //backendUrl: 'http://172.17.0.11:9090/api',
  //auth: 'http://172.17.0.11:9090',
};
